/** Shared look of the report's views/engagements charts (desktop, weekly and daily). */

export const VIEWS_COLOR = "#7B2FF7";
export const ENGAGEMENTS_COLOR = "#F72586";

const compact = new Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 1 });

/** 90.3K, 1.6M, 947. */
export const formatCompact = (value: number) => compact.format(value);

/** "16 Mar" for a `YYYY-MM-DD` day (UTC). */
export const formatDayMonth = (date: string) =>
	new Date(`${date}T00:00:00Z`).toLocaleDateString("en-AU", { day: "numeric", month: "short", timeZone: "UTC" });

/** "Mon 14 Sept", for a day's tooltip title. */
export const formatWeekdayDayMonth = (date: string) =>
	`${new Date(`${date}T00:00:00Z`).toLocaleDateString("en-AU", { weekday: "short", timeZone: "UTC" })} ${formatDayMonth(date)}`;

/** "Mon", for a week's x labels. */
export const formatWeekday = (date: string) =>
	new Date(`${date}T00:00:00Z`).toLocaleDateString("en-AU", { weekday: "short", timeZone: "UTC" });

/** A smooth line on one of the chart's value axes; views use `y`, engagements `y1`. */
export const lineDataset = (label: string, data: Array<number | null>, color: string, yAxisID: "y" | "y1") => ({
	label,
	data,
	borderColor: color,
	backgroundColor: color,
	tension: 0.4,
	borderWidth: 2,
	yAxisID,
});
